import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BatchService {

  constructor(private http: HttpClient) { }

  addBatch(data) {
    return this.http.post(`${environment.apiUrl}batch`, data);
  }

  updateBatch(id, data) {
    return this.http.put(`${environment.apiUrl}batch/${id}`, data);
  }

  getBatchListById(id: string) {
    return this.http.get(`${environment.apiUrl}batch/${id}`);
  }

  getBatchList(query: string) {
    return this.http.get(`${environment.apiUrl}batch?${query}`);
  }

  addBatchPlayer(data) {
    return this.http.post(`${environment.apiUrl}batchplayers`, data);
  }

  getBatchPlayerDataById(id: string) {
    return this.http.get(`${environment.apiUrl}batchplayers/${id}`);
  }

  updateBatchPlayer(id, data) {
    return this.http.put(`${environment.apiUrl}batchplayers/${id}`, data);
  }

  getBatchPlayerList(query: string) {
    return this.http.get(`${environment.apiUrl}batchplayers?${query}`);
  }

  addBatchPlayersAttendance(data) {
    return this.http.post(`${environment.apiUrl}attendance`, data);
  }

  updateBatchPlayersAttendance(batchId, data) {
    return this.http.put(`${environment.apiUrl}attendance/${batchId}`, data);
  }

  getBatchPlayersAttendanceList(query: string) {
    return this.http.get(`${environment.apiUrl}attendance?${query}`);
  }

  addBatchPlayerPerformance(data) {
    return this.http.post(`${environment.apiUrl}performance`, data);
  }

  updateBatchPlayerPerformance(playerPerformanceId, data) {
    return this.http.put(`${environment.apiUrl}performance/${playerPerformanceId}`, data);
  }

  getBatchPlayerPerformanceById(playerPerformanceId) {
    return this.http.get(`${environment.apiUrl}performance/${playerPerformanceId}`);
  }

  getBatchPlayerPerformance(query:string) {
    return this.http.get(`${environment.apiUrl}performance?${query}`);
  }

  addBulkPlayerPerformance(data) {
    return this.http.post(`${environment.apiUrl}performance/bulk`,data);
  }

  getBatchScheduleDetails(query: string) {
    return this.http.get(`${environment.apiUrl}batchday?${query}`);
  }

  getBatchScheduleDetailsById(id: string) {
    return this.http.get(`${environment.apiUrl}batchday/${id}`);
  }

  updateBatchScheduleDetails(id, batchScheduleData) {
    return this.http.put(`${environment.apiUrl}batchday/${id}`, batchScheduleData);
  }

}
